import { HttpMethod } from '../types.js';
export const ApiDef_ServerInfo = {
    v1: {
        getServerInfo: { method: HttpMethod.GET, path: 'v1/server-info' },
        updateServerInfoState: { method: HttpMethod.GET, path: 'v1/update-server-info' }
    }
};
//# sourceMappingURL=api.js.map